/* eslint-disable */
import * as React from 'react';

interface Props {
  text: string;
}

export const Label: React.FC<Props> = props => {
  return <h2 style={{ color: '#6373a3' }}>{props.text}</h2>;
};
try {
    // @ts-ignore
    Label.displayName = "Label";
    // @ts-ignore
    Label.__docgenInfo = { "description": "", "displayName": "Label", "props": { "text": { "defaultValue": null, "description": "", "name": "text", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Label/label.tsx#Label"] = { docgenInfo: Label.__docgenInfo, name: "Label", path: "src/components/Label/label.tsx#Label" };
}
catch (__react_docgen_typescript_loader_error) { }